/* ════════════════════════════════════════════════════════════════════
   TRANSDERMA · German (de) · Contact page
   English is the source of truth in contact.html; this file supplies the
   German counterpart for each contact.* data-i18n key. Missing keys fall
   back to English automatically (see i18n.js).

   House voice: calm, exact, short. No em dashes (use periods, commas,
   or the mid-dot · ). Product names (Transderma C/A/O/M/R, Discovery
   Kit, Moisture Serum) and the postal address stay as-is. Informal
   singular "du" throughout.
═════════════════════════════════════════════════════════════════════ */
(function(){
  window.TD_I18N = window.TD_I18N || {};
  window.TD_I18N.de = window.TD_I18N.de || {};
  Object.assign(window.TD_I18N.de, {

    /* ── Footer · extra link not on the homepage ── */
    'footer.learn.about': 'Über Dr. Ronlán',

    /* ── Page head ── */
    'contact.eyebrow': 'Nimm Kontakt auf',
    'contact.title': 'Fragen,<br>Anfragen,<br><em>oder einfach ein Hallo.</em>',
    'contact.intro': 'Presseanfragen, Händleranfragen, Fragen zur Routine, oder alles dazwischen. Wir lesen jede Nachricht. Antworten kommen meist innerhalb von zwei Werktagen.',

    /* ── Reach us ── */
    'contact.reach': 'Erreich uns',
    'contact.email.label': 'E-Mail',
    'contact.email.meta': 'Ideal für ausführliche Fragen',
    'contact.phone.label': 'Telefon',
    'contact.phone.meta': 'Mo – Fr · 9–17 Uhr EST',
    'contact.address.label': 'Adresse',
    'contact.address.meta': 'Rücksendungen und Korrespondenz',
    'contact.social.label': 'Finde uns in den sozialen Medien',

    /* ── Inquiry form ── */
    'contact.form.eyebrow': 'Anfrage senden',
    'contact.form.name': 'Name',
    'contact.form.subject': 'Betreff',
    'contact.form.email': 'E-Mail-Adresse',
    'contact.form.message': 'Nachricht',
    'contact.form.send': 'Senden',
    'contact.form.success': 'Danke für deine Nachricht · wir melden uns innerhalb von 1 bis 2 Werktagen.',

    /* ── Response windows ── */
    'contact.hours.eyebrow': 'Antwortzeiten',
    'contact.hours.email.label': 'E-Mail',
    'contact.hours.email.val': 'Innerhalb von 2 Werktagen',
    'contact.hours.phone.label': 'Telefon',
    'contact.hours.phone.val': '9–17 Uhr EST',
    'contact.hours.press.label': 'Presse',
    'contact.hours.press.val': 'Innerhalb von 1 Werktag',

    /* ── CTA ── */
    'contact.cta.title': 'Du weißt nicht, welches Serum das Richtige für dich ist?',
    'contact.cta.body': 'Das Discovery Kit enthält alle fünf Seren im Reiseformat. Die meisten wissen es in wenigen Tagen.',
    'contact.cta.button': 'Discovery Kit holen'

  });
})();
